import React from "react";
import { Button, Form, Col, Row } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../_metronic/_partials/controls";
import { useSelector } from "react-redux";
import { selectSelected } from "./clientSlice";
import { useHistory } from "react-router-dom";
import { formatDate } from "../../utility";

export const ClientDetail = () => {
  const history = useHistory();
  const items = useSelector(selectSelected);

  // Return if data null
  if (items === null) {
    history.push("/client");
  }

  return items === null ? null : (
    <Card>
      <CardHeader title="Client Detail"></CardHeader>
      <CardBody>
        <Form>
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>APL Return Number </b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control disabled value={items.retNumber} />
                </Col>
              </Form.Group>
              {/* <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Invoice Ref Number</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control disabled value={items.invoiceNo} />
                </Col>
              </Form.Group> */}
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Reason</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control disabled value={items.reasonName} />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>APL Sales Office</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control disabled value={items.aplSalesOffice} />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Cust Name</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control disabled value={items.customerName} />
                </Col>
              </Form.Group>

              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Doc Date</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control disabled value={formatDate(items.docDate)} />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Division(PH3)</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control disabled value={items.divisionPh3} />
                </Col>
              </Form.Group>
            </Col>
            {/* Row kiri */}
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Material</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control disabled value={items.materialCode} />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Material Desc</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control disabled value={items.materialName} />
                </Col>
              </Form.Group>

              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Batch</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control disabled value={items.batch} />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Uom</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control disabled value={items.uom} />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Qty</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control disabled value={items.qty} />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Exp Date</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control
                    disabled
                    value={formatDate(items.expiredDate)}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Remark</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control disabled value={items.remark} />
                </Col>
              </Form.Group>
            </Col>
            {/* end kiri */}
          </Form.Group>
        </Form>

        <Row className="mt-6">
          <Button
            variant="light"
            className="mr-3"
            onClick={() => history.push("/client")}
          >
            <i className="fa fa-arrow-left" />
            Back
          </Button>
        </Row>
      </CardBody>
    </Card>
  );
};
